/**
 * Partner-admin manual property statuses until MLS sync is live.
 * Must stay aligned with MF-Backend/global/customPropertyStatuses.js.
 */
export const CUSTOM_PROPERTY_STATUSES = [
  { value: 'active', label: 'Active' },
  { value: 'active_under_contract', label: 'Active under contract' },
  { value: 'application_pending', label: 'Application pending' },
  { value: 'coming_soon', label: 'Coming soon' },
  { value: 'contract_signed', label: 'Contract signed' },
  { value: 'for_lease', label: 'For lease' },
  { value: 'for_sale', label: 'For sale' },
  { value: 'inactive', label: 'Inactive' },
  { value: 'in_contract', label: 'In contract' },
  { value: 'lease', label: 'Lease' },
  { value: 'lease_signed', label: 'Lease signed' },
  { value: 'new_development', label: 'New development' },
  { value: 'off_market', label: 'Off market' },
  { value: 'pending', label: 'Pending' },
  { value: 'pocket_listing', label: 'Pocket listing' },
  { value: 'private_listing', label: 'Private listing' },
  { value: 'rented', label: 'Rented' },
  { value: 'sold', label: 'Sold' },
  { value: 'taken_off_market', label: 'Taken off market' },
  { value: 'under_attorney_review', label: 'Under attorney review' },
  { value: 'under_contract', label: 'Under contract' },
];

export const CUSTOM_PROPERTY_STATUS_LABELS = Object.fromEntries(
  CUSTOM_PROPERTY_STATUSES.map(({ value, label }) => [value, label])
);

export const CUSTOM_PROPERTY_STATUS_SET = new Set(
  CUSTOM_PROPERTY_STATUSES.map(({ value }) => value)
);

export const getCustomPropertyStatusLabel = (value) =>
  CUSTOM_PROPERTY_STATUS_LABELS[value] || null;
